import React from 'react'
import {Col, ListGroup} from 'reactstrap'
import {Link, withRouter} from 'react-router-dom'
import Loader from 'react-loader-spinner'
import {ControllerProvisioningListItem, InfoAlert, ProvisionControllerForm} from '../../ui'
import {provisioningHelpers} from '../../../dataHelpers'
import {Controller} from "../../../models"
import {pageHelpers} from "../"
import ProvisionControllerIcon from 'react-icons/lib/fa/plus-square'
import '../../../stylesheets/Provision.css'

const PROVISIONING_STATE_STORAGE_KEY = "marksman_controller_provisioning_state"
const PROVISIONING_INFO_ALERT_KEY = "provision_controller_1"
const PROVISIONING_INFO_ALERT_MOBILE_KEY = "provision_controller_mobilewarn_1"

class ProvisionPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {token} = props

        let oldStateFromStorage = sessionStorage.getItem(PROVISIONING_STATE_STORAGE_KEY)
        if (oldStateFromStorage) {
            this.state = JSON.parse(oldStateFromStorage)
            this.state.token = token
            this.state.isMobileDevice = pageHelpers.userOnMobileDevice()
            this.state.errors = []
            this.state.userConfirmationRequests = []
        } else {
            this.state = {
                token,
                isMobileDevice: pageHelpers.userOnMobileDevice(),
                loading: false,
                errors: [],
                userConfirmationRequests: [],
                provisionedControllers: [],
                reprovisionedControllers: [],
                usernames: [],
                passwords: []
            }
        }

        this.submitForm = this.submitForm.bind(this)
        this.provisionSerialNumbers = this.provisionSerialNumbers.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.fetchProvisionedControllersState = this.fetchProvisionedControllersState.bind(this)
        this.dismissUserConfirmationRequest = this.dismissUserConfirmationRequest.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const {token} = nextProps
        pageHelpers.setupPropsForPage(nextProps, this)
        this.setState({token, isMobileDevice: pageHelpers.userOnMobileDevice()})
    }

    dismissUserConfirmationRequest(req) {
        let userConfirmationRequests = this.state.userConfirmationRequests.filter((r) => r !== req)
        this.setState({userConfirmationRequests})
    }

    async fetchProvisionedControllersState() {
        let {provisionedControllers, token} = this.state
        for (let i = 0; i < provisionedControllers.length; i++) {
            let controller = provisionedControllers[i]
            let searchResponse = await provisioningHelpers.searchSerialNumber(token, controller.serialNumber)

            if (!searchResponse.error && searchResponse.controller) {
                provisionedControllers[i] = searchResponse.controller
            }
        }
        this.setState({provisionedControllers})
    }

    async provisionSerialNumbers(serialNumbers, iccid, phoneNumber, forceReprovision = false, uns = [], pws = []) {
        let {token, usernames, passwords, provisionedControllers} = this.state
        let responses = await provisioningHelpers.provisionSerialNumbers(token, serialNumbers, iccid, phoneNumber, forceReprovision, uns, pws)
        let errors = responses.map((r) => r.error).filter((e) => e).reverse()
        if (errors.length > 0) {
            this.setState({errors})
        }

        let userConfirmationRequests = responses.map((r) => r.userConfirmationRequest).filter((r) => r).reverse()
        for (let i = 0; i < userConfirmationRequests.length; i++) {
            let req = userConfirmationRequests[i]
            req.confirm = async ({controller, username, password}) => {
                await this.provisionSerialNumbers([req.confirmObject.controller.serialNumber], [req.confirmObject.iccid_val], [req.confirmObject.phone], true, [req.confirmObject.username], [req.confirmObject.password])
                this.dismissUserConfirmationRequest(req)
                usernames.push(username)
                passwords.push(password)
                provisionedControllers.push(controller)
                this.setState({usernames, passwords, provisionedControllers})
            }
            req.dismiss = () => (this.dismissUserConfirmationRequest(req))
        }
        if (userConfirmationRequests.length > 0) {
            this.setState({userConfirmationRequests})
        }

        return responses.filter((r) => !r.error)
    }

    async submitForm(serialNumbers, iccid, phoneNumber) {
        this.setState({loading: true})

        let {provisionedControllers, usernames, passwords} = this.state

        let responses = await this.provisionSerialNumbers(serialNumbers, iccid, phoneNumber)
        let newProvisionedControllers = responses.filter((r) => !r.error && !r.userConfirmationRequest).map((r) => r.controller)
        provisionedControllers = provisionedControllers.concat(newProvisionedControllers)
        let reprovisionedControllers = responses.filter((r) => r.userConfirmationRequest).map((r) => r.controller)

        let newUsernames = responses.map((response) => response.username)
        usernames = usernames.concat(newUsernames)

        let newPasswords = responses.map((response) => response.password)
        passwords = passwords.concat(newPasswords)

        this.setState({loading: false, provisionedControllers, reprovisionedControllers, usernames, passwords})
        sessionStorage.setItem(PROVISIONING_STATE_STORAGE_KEY, JSON.stringify(this.state))
    }

    handleWebSocketResponse(data) {
        let result = JSON.parse(data)
        let updatedController = Controller.fromAPIObject(result)
        let {provisionedControllers} = this.state
        let filteredControllers = provisionedControllers.filter((controller) => controller.id !== updatedController.id)
        if (filteredControllers.length < provisionedControllers.length) {
            let provisionedControllers = filteredControllers
            provisionedControllers.push(updatedController)
            this.setState({provisionedControllers})
            sessionStorage.setItem(PROVISIONING_STATE_STORAGE_KEY, JSON.stringify(this.state))
        }
    }

    render() {
        let {usernames, passwords, loading, provisionedControllers, reprovisionedControllers, errors, userConfirmationRequests, isMobileDevice, token} = this.state
        return (
            <Col xs={12} className="text-center">
                <h1 className="col-12 no-gutters mb-2 d-block d-sm-none light-sf-orange font-weight-bold"><ProvisionControllerIcon
                    className="light-sf-blue mr-2"/>Provision Controllers</h1>
                <h1 className="col-12 no-gutters mb-2 d-none d-sm-block light-sf-orange font-weight-bold"><ProvisionControllerIcon
                    className="light-sf-blue mr-2"/>Provision New Marksman Controllers</h1>
                <p className="col-12 mb-4">
                    <Link className="light-sf-blue" to="/management/controllers">or look up an existing controller</Link>
                </p>
                <InfoAlert
                    header="Provisioning Controllers"
                    body="Provisioning a new Marksman controller will create a record for it in the Marksman service. This process will also generate a Login file that the newly manufactured controller will need to log in with the service before it can upload data or receive commands."
                    alertKey={PROVISIONING_INFO_ALERT_KEY}/>
                {isMobileDevice ?
                    <InfoAlert
                        header="Using your phone or tablet?"
                        body="Your mobile device probably can't load the Login file for a new controller onto a USB drive. You'll need to send Login files to a PC to be loaded onto a controller."
                        alertKey={PROVISIONING_INFO_ALERT_MOBILE_KEY}/>
                    : null}
                {loading ?
                        <Col xs={12} className="text-center m-4">
                            <Loader type="TailSpin" color="orange" width={60} height={60}/>
                        </Col> :
                            <ProvisionControllerForm onSubmit={(serials, iccid, phone) => this.submitForm(serials, iccid, phone)}/>}
                {(provisionedControllers.length > 0 && token ?
                    <Col xs={12} id="provisioned-controllers" className="no-gutters">
                        <h3 className="col-12">Provisioned Controllers</h3>
                        <ListGroup>
                            {provisionedControllers.map((controller, idx) => (
                                <ControllerProvisioningListItem controller={controller}
                                                                key={`${controller.id}-${idx}`}
                                                                username={usernames[idx]}
                                                                reprovisioned={reprovisionedControllers.includes(controller)}
                                                                token={token}
                                                                downloadLoginLink={provisioningHelpers.downloadLinkForLogin(usernames[idx], passwords[idx])}
                                                                isMobileDevice={isMobileDevice}
                                                                handleWebSocketResponse={this.handleWebSocketResponse}/>
                            ))}
                        </ListGroup>
                    </Col>
                    : null)}

                {pageHelpers.renderErrorModalsForPage(errors, this)}
                {pageHelpers.renderUserConfirmationModals(userConfirmationRequests)}
            </Col>)
    }
}

export default withRouter(ProvisionPage)



// WEBPACK FOOTER //
// ./src/components/pages/controllers/ProvisionPage.js